import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiCamera({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.4453 1.63036C5.56894 1.4449 5.7771 1.3335 6 1.3335H10C10.2229 1.3335 10.4311 1.4449 10.5547 1.63036L11.6901 3.3335H14C14.5304 3.3335 15.0391 3.54421 15.4142 3.91928C15.7893 4.29436 16 4.80306 16 5.3335V12.6668C16 13.1973 15.7893 13.706 15.4142 14.081C15.0391 14.4561 14.5304 14.6668 14 14.6668H2C1.46957 14.6668 0.960859 14.4561 0.585786 14.081C0.210714 13.706 0 13.1973 0 12.6668V5.3335C0 4.80306 0.210714 4.29436 0.585786 3.91928C0.960859 3.54421 1.46957 3.3335 2 3.3335H4.30988L5.4453 1.63036ZM6.35679 2.66683L5.22137 4.36996C5.09772 4.55543 4.88957 4.66683 4.66667 4.66683H2C1.82319 4.66683 1.65362 4.73707 1.5286 4.86209C1.40357 4.98712 1.33333 5.15669 1.33333 5.3335V12.6668C1.33333 12.8436 1.40357 13.0132 1.5286 13.1382C1.65362 13.2633 1.82319 13.3335 2 13.3335H14C14.1768 13.3335 14.3464 13.2633 14.4714 13.1382C14.5964 13.0132 14.6667 12.8436 14.6667 12.6668V5.3335C14.6667 5.15669 14.5964 4.98712 14.4714 4.86209C14.3464 4.73707 14.1768 4.66683 14 4.66683H11.3333C11.1104 4.66683 10.9023 4.55543 10.7786 4.36996L9.64321 2.66683H6.35679Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.00002 6.66683C6.89545 6.66683 6.00002 7.56226 6.00002 8.66683C6.00002 9.7714 6.89545 10.6668 8.00002 10.6668C9.10459 10.6668 10 9.7714 10 8.66683C10 7.56226 9.10459 6.66683 8.00002 6.66683ZM4.66669 8.66683C4.66669 6.82588 6.15907 5.3335 8.00002 5.3335C9.84097 5.3335 11.3334 6.82588 11.3334 8.66683C11.3334 10.5078 9.84097 12.0002 8.00002 12.0002C6.15907 12.0002 4.66669 10.5078 4.66669 8.66683Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgFiCamera;
